export function hasActivityActorUserId(userId: unknown): userId is string | number {
  return userId != null && String(userId).length > 0;
}

/** Actor id for attaching a related user. Empty / null `user_id` is unresolved — never `target_id`. */
export function getActivityActorId(activity: {
  user_id?: string | number | null;
}): string | null {
  if (hasActivityActorUserId(activity.user_id)) return String(activity.user_id);
  return null;
}
